import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MedTextareaComponent } from "./med-textarea.component";
import { MedLabelModule } from "../med-label/med-label.module";

@NgModule({
  declarations: [
    MedTextareaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedLabelModule,
  ],
  exports: [
    MedTextareaComponent,
  ],
})
export class MedTextareaModule { }
